export default __webpack_public_path__ + "static/media/close.565c4592.svg";